export default __webpack_public_path__ + "static/media/logo-psychflex-color.460e3e9c.png";